import {
    Component,
    ChangeDetectionStrategy,
    ViewChild,
    Input,
    Type,
    OnChanges,
} from '@angular/core';
import { ItemContentDirective } from '../../directives/item-content.directive';
import { ListItemComponent as ListItemComponentInterface, ListItem } from '@ui/shared/util-list';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss'],
    standalone: false,
})
export class ListItemComponent<ListItemType extends ListItem> implements OnChanges {
    @Input({ required: true })
    public listItem!: ListItemType;

    @Input()
    public itemContentComponentType!: Type<ListItemComponentInterface<ListItemType>>;

    @ViewChild(ItemContentDirective, { static: true })
    public uiItemContentHost?: ItemContentDirective;

    public loadPopupContent(): void {
        if (!this.uiItemContentHost) {
            return;
        }

        const viewContainerRef = this.uiItemContentHost.viewContainerRef;

        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(this.itemContentComponentType);

        componentRef.instance.listItem = this.listItem;
    }

    public ngOnChanges(): void {
        this.loadPopupContent();
    }
}
